import { render, staticRenderFns } from "./ConfirmReceipt.vue?vue&type=template&id=0af29152&scoped=true"
import script from "./ConfirmReceipt.vue?vue&type=script&lang=js"
export * from "./ConfirmReceipt.vue?vue&type=script&lang=js"
import style0 from "./ConfirmReceipt.vue?vue&type=style&index=0&id=0af29152&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0af29152",
  null
  
)

export default component.exports